module.exports = __webpack_public_path__ + "assets/envelope.8c0ce5d4c64feb41fb5b7ad552154144.png";